import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLogoZapier = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	overflow: "visible",
	style: { display: "block" },
	viewBox: "0 0 89.731 24.6037",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsxs("g", {
			id: "Frame",
			clipPath: "url(#clip0_136_42)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					id: "Vector",
					d: "M21.3508 16.7314L21.3384 16.692L29.2008 9.49407V6.02595H16.587V9.49407H24.1212L24.1336 9.52728L16.348 16.7314V20.1995H29.3275V16.7314H21.3508Z",
					fill: "var(--fill-0, #FAF5F5)",
					fillOpacity: .45
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Vector_2",
					d: "M37.0707 5.69733C35.6158 5.69733 34.4301 5.91674 33.5135 6.35565C32.6597 6.73811 31.9406 7.36831 31.4492 8.16444C30.9793 8.96581 30.6841 9.85757 30.5832 10.7811L34.4107 11.319C34.549 10.5035 34.826 9.9255 35.2414 9.58491C35.7135 9.22871 36.2953 9.04873 36.8861 9.07614C37.663 9.07614 38.2264 9.28378 38.5763 9.69913C38.9234 10.1145 39.1 10.6897 39.1 11.4477V11.8257H35.42C33.5468 11.8257 32.201 12.241 31.3828 13.0717C30.5645 13.9024 30.1561 14.999 30.1576 16.3613C30.1576 17.7567 30.566 18.7952 31.3828 19.4762C32.1997 20.1575 33.2269 20.496 34.4646 20.4918C36.0001 20.4918 37.1812 19.9635 38.0074 18.9073C38.4957 18.2581 38.8444 17.515 39.0314 16.7247H39.1703L39.6978 20.1928H43.1659V11.4103C43.1659 9.59529 42.6878 8.18939 41.7311 7.19255C40.7743 6.19571 39.2208 5.69733 37.0707 5.69733ZM38.2837 16.5232C37.7333 16.9822 37.0127 17.2105 36.1155 17.2105C35.3763 17.2105 34.8626 17.0811 34.5746 16.8222C34.4344 16.6998 34.3228 16.5478 34.2477 16.3775C34.1727 16.2068 34.1363 16.022 34.1406 15.8358C34.1325 15.6602 34.1601 15.4848 34.2219 15.3202C34.2836 15.1557 34.3782 15.0053 34.5 14.8784C34.6315 14.7551 34.7868 14.6596 34.9563 14.5978C35.1259 14.5361 35.3062 14.5093 35.4864 14.5192H39.1061V14.758C39.1133 15.0956 39.0429 15.4304 38.9005 15.7363C38.758 16.0424 38.547 16.3116 38.2837 16.5232Z",
					fill: "var(--fill-0, #FAF5F5)",
					fillOpacity: .45
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Vector_3",
					d: "M64.1324 6.0257H60.0351V20.2014H64.1324V6.0257Z",
					fill: "var(--fill-0, #FAF5F5)",
					fillOpacity: .45
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Vector_4",
					d: "M88.3189 6.0257C87.1613 6.0257 86.249 6.43411 85.5816 7.25096C85.1027 7.83798 84.7386 8.70534 84.4895 9.85306H84.369L83.8332 6.0257H80.334V20.1992H84.4315V12.9307C84.4315 12.0143 84.6461 11.3116 85.0752 10.8229C85.5044 10.3342 86.2962 10.0898 87.4508 10.0898H89.0062V6.0257H88.3189Z",
					fill: "var(--fill-0, #FAF5F5)",
					fillOpacity: .45
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Vector_5",
					d: "M76.2776 6.49123C75.3214 5.92221 74.1145 5.6384 72.6582 5.63977C70.3654 5.63977 68.5711 6.29256 67.2754 7.59812C65.9792 8.90366 65.3315 10.7035 65.3315 12.9976C65.2985 14.3845 65.6013 15.7589 66.2141 17.0035C66.7751 18.1127 67.6486 19.0332 68.727 19.6513C69.8122 20.2786 71.1031 20.5928 72.6002 20.5942C73.8945 20.5942 74.9756 20.3948 75.8438 19.9961C76.6599 19.638 77.3704 19.0767 77.9082 18.3658C78.4197 17.668 78.7999 16.8827 79.0293 16.0482L75.4992 15.0597C75.3503 15.6023 75.0643 16.0972 74.6685 16.4968C74.2695 16.8956 73.6014 17.095 72.6644 17.095C71.5498 17.095 70.719 16.7757 70.1722 16.1376C69.7754 15.6765 69.5265 15.0182 69.4163 14.1647H79.0834C79.1229 13.7659 79.1436 13.4316 79.1436 13.1616V12.279C79.1669 11.0933 78.9222 9.91768 78.4273 8.83998C77.9641 7.85825 77.2147 7.0395 76.2776 6.49123ZM72.5398 9.01858C74.2013 9.01858 75.143 9.8361 75.3659 11.4712H69.489C69.5823 10.9256 69.8085 10.4114 70.1472 9.97388C70.686 9.33565 71.4833 9.0172 72.5398 9.01858Z",
					fill: "var(--fill-0, #FAF5F5)",
					fillOpacity: .45
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Vector_6",
					d: "M62.1285 0.313105C61.8204 0.302621 61.5131 0.354207 61.2253 0.464801C60.9374 0.575396 60.6749 0.742734 60.4527 0.956878C60.234 1.17308 60.0624 1.43241 59.9491 1.71841C59.8357 2.0044 59.7832 2.31082 59.7943 2.61825C59.7835 2.92766 59.8362 3.23603 59.9498 3.52411C60.0631 3.81221 60.2347 4.07383 60.4537 4.29266C60.6727 4.51147 60.9344 4.6828 61.2227 4.79598C61.511 4.90914 61.8192 4.96171 62.1285 4.95039C62.436 4.962 62.7424 4.90947 63.0286 4.79615C63.3147 4.6828 63.5739 4.51114 63.79 4.29207C64.0045 4.07075 64.1715 3.80839 64.2819 3.52073C64.3923 3.23308 64.4431 2.9261 64.4318 2.61825C64.446 2.31221 64.3962 2.00659 64.2855 1.72088C64.1748 1.43519 64.0059 1.17569 63.7895 0.95897C63.5729 0.742245 63.3135 0.573054 63.0278 0.462203C62.7424 0.351353 62.4368 0.301283 62.1307 0.315183L62.1285 0.313105Z",
					fill: "var(--fill-0, #FAF5F5)",
					fillOpacity: .45
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Vector_7",
					d: "M53.671 5.63977C52.2754 5.63977 51.1539 6.07794 50.3068 6.95433C49.6794 7.60363 49.219 8.57276 48.9258 9.86173H48.795L48.2592 6.03435H44.76V24.2762H48.8571V16.7627H49.0067C49.1316 17.2636 49.307 17.7506 49.5299 18.2163C49.8767 18.9749 50.4452 19.6106 51.1604 20.0396C51.9018 20.4444 52.7372 20.6457 53.5817 20.6233C55.2971 20.6233 56.6032 19.9552 57.5003 18.6193C58.3973 17.2831 58.8461 15.419 58.8461 13.0266C58.8461 10.7159 58.412 8.90715 57.5442 7.60017C56.6761 6.29325 55.385 5.63977 53.671 5.63977ZM54.0863 15.9111C53.6086 16.6033 52.8609 16.9495 51.8434 16.9495C51.4239 16.9689 51.0057 16.888 50.6237 16.7136C50.2415 16.5391 49.9063 16.2763 49.6464 15.9464C49.116 15.2805 48.8517 14.3689 48.8532 13.2114V12.9415C48.8532 11.766 49.1174 10.8661 49.6464 10.2417C50.1751 9.61734 50.9077 9.30862 51.8434 9.31553C52.8792 9.31553 53.6315 9.64435 54.1008 10.302C54.5703 10.9596 54.8049 11.8768 54.8049 13.0536C54.8078 14.2705 54.5696 15.2231 54.0904 15.9111H54.0863Z",
					fill: "var(--fill-0, #FAF5F5)",
					fillOpacity: .45
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Vector_8",
					d: "M14.7579 16.7317H0.58229V20.204H14.7579V16.7317Z",
					fill: "var(--fill-0, #FAF5F5)",
					fillOpacity: .45
				})
			]
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_136_42",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 89.731,
				height: 24.6037,
				fill: "white"
			})
		}) })
	]
});
const ForwardRef = forwardRef(SvgLogoZapier);
export { ForwardRef as ReactComponent };
